import { useState } from 'react'
import './Projects.css'

import Project from '../../Components/Project/Project'
import SEO from '../../Components/SEO/SEO';
import PageTitle from '../../Hooks/PageTitle';

// import not_available_image_project from '../../Media/Projects.Media/not_available_image_project.jpg'
import adas from '../../Media/Projects.Media/adas.jpg'
import synesthesia from '../../Media/Projects.Media/synesthesia.jpg'
import echomind from '../../Media/Projects.Media/echomind.jpg'
import mindscan from '../../Media/Projects.Media/mindscan.jpg'
// import bugscope from '../../Media/Projects.Media/bugscope.jpg'
import cyber from '../../Media/Projects.Media/cyber.jpg'
import genx from '../../Media/Projects.Media/genx.jpg'
import lens from '../../Media/Projects.Media/lens.jpg'
import minejobs from '../../Media/Projects.Media/minejobs.jpg'
import intervuai from '../../Media/Projects.Media/intervuai.jpg'
import spidy from '../../Media/Projects.Media/spidy.jpg'
import pulsetrack from '../../Media/Projects.Media/pulsetrack.jpg'
import pulsex from '../../Media/Projects.Media/pulsex.jpg'
import dermalyze from '../../Media/Projects.Media/dermalyze.jpg'
import clarix from '../../Media/Projects.Media/clarix.jpg'
import clinicalNER from '../../Media/Projects.Media/clinicalNER.jpg'
import dialex from '../../Media/Projects.Media/dialex.jpg'
import notex from '../../Media/Projects.Media/notex.jpg'
import chronix from '../../Media/Projects.Media/chronix.jpg'
import herma from '../../Media/Projects.Media/herma.jpg'
// import portfolio from '../../Media/Projects.Media/portfolio.jpg'
import cortext from '../../Media/Projects.Media/cortext.jpg'
// import moroccoinsights from '../../Media/Projects.Media/moroccoinsights.jpg'
import neurolink from '../../Media/Projects.Media/neurolink.jpg'
import neurodrive from '../../Media/Projects.Media/neurodrive.jpg'
// import therabot from '../../Media/Projects.Media/therabot.jpg'
import heatz from '../../Media/Projects.Media/heatz.jpg'
// import medieval from '../../Media/Projects.Media/medieval.jpg'
// import whisper from '../../Media/Projects.Media/whisper.jpg'
// import logspectrum from '../../Media/Projects.Media/logspectrum.jpg'
// import cabinetpro from '../../Media/Projects.Media/cabinetpro.jpg'
import ibulk from '../../Media/Projects.Media/ibulk.jpg'
// import schoolpad from '../../Media/Projects.Media/schoolpad.jpg'
// import colorclash from '../../Media/Projects.Media/colorclash.jpg'

const Projects = ({ ShowMessage }) => {
    PageTitle('Projects');
    const [selectedType, setSelectedType] = useState('All Types');
    const [selectedField, setSelectedField] = useState('All Fields');
    const [selectedSkill, setSelectedSkill] = useState('All Skills');
    const [selectedDate, setSelectedDate] = useState('All Years');

    const handleFilterChange = (event, setter) => {
        setter(event.target.value);
    };

    const filterProjects = (project) => {
        const typeMatch = selectedType === 'All Types' || project.type === selectedType;
        const fieldMatch = selectedField === 'All Fields' || project.field === selectedField;
        const skillMatch = selectedSkill === 'All Skills' || project.skill === selectedSkill;
        const dateMatch = selectedDate === 'All Years' || project.date === selectedDate;

        return typeMatch && fieldMatch && skillMatch && dateMatch;
    };

    const projects = [
        // description:'Working on it! stay tunned',
        // onClick:() => alert('This is the project I am currently working on. Exciting!'),
        // image: not_available_image_project,
        {
            available: true,
            onClick:() => window.open('https://drive.google.com/file/d/1rTvfjHQY0xErMYkXVPCzTfKc-LIK6xNI/view?usp=sharing', '_blank'),
            image: adas,
            type:'Professional',
            field:'Autonomous Vehicles',
            skill:'Computer Vision',
            other:'',
            title:'DriveScope 🏎️',
            date:'2026',
            description:<>
                Designed a hallucination-resistant driving system using {StyleMetrics('3')} pipelines with LLM-based
                validation, avoiding monolithic VLA/VLM designs. Built a {StyleMetrics('900')}-frame labeled dataset,
                achieving {StyleMetrics('78%')} micro F1, {StyleMetrics('~620ms')} latency and {StyleMetrics('0.659 mAP50')} 
                detection.
            </>,
            tools:[
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'},
                {name:'CARLA', backgroundColor:'rgb(0, 0, 0)'},
            ]
        },
        {
            available: true,
            onClick:() => window.open('https://darttgoblin.github.io/Synesthesia/Synesthesia.html', '_blank'),
            image: synesthesia,
            type:'Academic',
            field:'Art',
            skill:'Recommandation Systems',
            other:'',
            title:'Synesthesia 🖼️',
            date:'2026',
            description:<>
                Cross-modal recommendation system linking paintings and music through emotional content using dual-encoder 
                architecture, achieving {StyleMetrics('64.1%')} image and {StyleMetrics('79.2%')} audio emotion classification 
                with {StyleMetrics('6.2%')} cross-modal retrieval accuracy.
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'}
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://darttgoblin.github.io/EchoMind/EchoMind.html', '_blank'),
            image: echomind,
            type:'Academic',
            field:'Business',
            skill:'Generative AI',
            other:'',
            title:'EchoMind 🎞️',
            date:'2026',
            description:<>
                Text-conditioned audio effect generation system using latent-space manipulation with 5 sound effect, 
                achieving {StyleMetrics('95–100%')} in-distribution, {StyleMetrics('80–90%')} out-of-distribution similarity, 
                and fastest convergence at {StyleMetrics('40 epochs')} with 5-second perceptual optimization.
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'}
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://darttgoblin.github.io/MindScan/MindScan.html', '_blank'),
            image: mindscan,
            type:'Academic',
            field:'Healthcare',
            skill:'Computer Vision',
            other:'',
            title:'MindScan 🧠',
            date:'2025',
            description:<>
                Deep learning platform for brain MRI scans that detects and classifies tumors using a dual-stage architecture 
                with MobileNetV2 and contrast-enhanced preprocessing, achieving {StyleMetrics('99%')} binary 
                and {StyleMetrics('91.3%')} multi-class accuracy for fast, lightweight web deployment.
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'}
            ]
        },
        // {
        //     available:true,
        //     onClick:() => window.open('https://darttgoblin.github.io/BugScope/BugScope.html', '_blank'),
        //     image: bugscope,
        //     type:'Academic',
        //     field:'Education',
        //     skill:'Other',
        //     other:'Software Engineering',
        //     title:'BugScope 🪲',
        //     date:'2025',
        //     description:<>
        //         Software engineering project applying Agile and SCRUM practices to design a defect-risk prediction system, from 
        //         requirements and user stories to architecture, implementation, evaluation, and reporting using static code metrics 
        //         for effective quality assurance.
        //     </>,
        //     tools:[
        //         {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
        //         {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
        //         {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
        //         {name:'Python', backgroundColor:'rgb(45, 70, 90)'}
        //     ]
        // },
        {
            available:true,
            onClick:() => window.open('https://darttgoblin.github.io/CyberQuiz/CyberQuiz.html', '_blank'),
            image: cyber,
            type:'Academic',
            field:'Cybersecurity',
            skill:'Web Development',
            other:'',
            title:'CyberQuiz 📝',
            date:'2025',
            description:<>
                Interactive web app that enhances cybersecurity awareness through engaging quizzes, real-time feedback, and 
                adaptive difficulty levels. Could also be used for data collection such as user mistakes, answering durations 
                and questions skipped, to train LLMs 
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://darttgoblin.github.io/GenX/GenX.html', '_blank'),
            image: genx,
            type:'Academic',
            field:'Business',
            skill:'Generative AI',
            other:'',
            title:'GenX 🎥',
            date:'2025',
            description:<>
                AI-powered tool that generates movies and series posters. Fine-tuned Stable Diffusion model on a movie poster 
                dataset from Hugging Face to generate high-quality images from user inputs, including title, description, 
                and theme, achieving {StyleMetrics('7 seconds')} latency per image.
            </>,

            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'}
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://github.com/DarttGoblin/LENS', '_blank'),
            image: lens,
            type:'Personal',
            field:'Business',
            skill:'Web Scraping',
            other:'',
            title:'LENS 🔍',
            date:'2025',
            description:<>
                Web scraping tool that extracts articles on the Israel-Palestine conflict from The Guardian and Al 
                Jazeera, transforming raw data into structured insights. Supports automated extraction, and 
                organized analysis for research and information tracking purposes.
            </>,
            tools:[
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'},
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://github.com/DarttGoblin/MineJobs', '_blank'),
            image: minejobs,
            type:'Personal',
            field:'Business',
            skill:'Web Scraping',
            other:'',
            title:'MineJobs ⛏️',
            date:'2025',
            description:<>
                Smart web scraping tool that mines job listings from multiple online sources, organizing them into 
                structured, easily accessible data. Supports automated extraction, filtering, and sorting to help 
                users discover opportunities efficiently and streamline career-related research.
            </>,
            tools:[
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'},
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://darttgoblin.github.io/Intervu.AI/Intervu.AI.html', '_blank'),
            image: intervuai,
            type:'Personal',
            field:'Business',
            skill:'Web Development',
            other:'',
            title:'Intervu.AI 💼',
            date:'2025',
            description:<>
                Interview platform that streamlines recruitment by automating candidate assessments, evaluating written 
                or spoken responses with AI, and generating clear, data-driven insights to support faster and more 
                informed hiring decisions.
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'}
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://github.com/DarttGoblin/Spidy', '_blank'),
            image: spidy,
            type:'Personal',
            field:'Social',
            skill:'RAG Systems',
            other:'',
            title:'Spidy 🕷️',
            date:'2025',
            description:<>
                AI-powered portfolio chatbot that guides users through my work, answers questions with context awareness, 
                highlights relevant projects, events, certifications and streamlines navigation for a smooth, interactive 
                browsing experience.
            </>,
            tools:[
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'},
                {name:'Node.js', backgroundColor:'rgb(43, 90, 50)'}
            ]
        },
        {
            available: true,
            onClick: () => window.open('https://darttgoblin.github.io/PulseTrack/PulseTrack.Pages/Home/Home.html', '_blank'),
            image: pulsetrack,
            type:'Personal',
            field:'Healthcare',
            skill:'Internet of Things',
            other:'',
            title:'PulseTrack 👁️',
            date:'2025',
            description:<>
                Provides an interactive web interface for monitoring, analyzing, and visualizing heart health 
                metrics using real-time PulseX device data, enabling fast insights, early anomaly detection, 
                and an accessible overview of cardiovascular activity.
            </>,
            tools: [
                { name:'HTML', backgroundColor:'rgb(134, 67, 67)' },
                { name:'CSS', backgroundColor:'rgb(32, 57, 101)' },
                { name:'JavaScript', backgroundColor:'rgb(81, 75, 20)' },
                { name:'Python', backgroundColor:'rgb(45, 70, 90)' }
            ]
        },
        {
            available: true,
            onClick: () => window.open('https://github.com/DarttGoblin/PulseX', '_blank'),
            image: pulsex,
            type:'Personal',
            field:'Healthcare',
            skill:'Robotics',
            other:'',
            title:'PulseX 🩺',
            date:'2025',
            description:<>
                AI-powered intelligent stethoscope for real-time cardiovascular anomaly detection and proactive health screening. 
                Fine-tuned ResNet-18 on BMD-HS dataset, deployed on Raspberry Pi, achieving {StyleMetrics('92.96%')} binary 
                and {StyleMetrics('77.57%')} multi-class F1 scores.
            </>,
            tools: [
                { name:'Python', backgroundColor:'rgb(45, 70, 90)' },
                { name:'Raspberry Pi', backgroundColor:'rgb(95, 40, 55)' }
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://darttgoblin.github.io/Dermalyze/Dermalyze.html', '_blank'),
            image: dermalyze,
            type:'Academic',
            field:'Healthcare',
            skill:'Computer Vision',
            other:'',
            title:'Dermalyze 🎗️',
            date:'2025',
            description:<>
                AI-powered system to classify skin lesion images, detecting normal and cancerous cases for early skin 
                cancer detection and classification. Fine-tuned EfficientNetV2B0 on HAM10000 dataset, 
                achieving {StyleMetrics('93%')} binary and {StyleMetrics('94%')} multi-class accuracy.
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'}
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://github.com/DarttGoblin/Clarix', '_blank'),
            image: clarix,
            type:'Academic',
            field:'Education',
            skill:'Robotics',
            other:'',
            title:'Clarix 🧽',
            date:'2025',
            description:<>
                Automates whiteboard cleaning and digitization by capturing and saving board content with a Raspberry 
                Pi, applying OCR for text extraction, and using a servo-driven brush for physical cleaning, all 
                coordinated through an AI-powered system.
            </>,
            tools:[
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'},
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://github.com/DarttGoblin/ClinicalNER', '_blank'),
            image: clinicalNER,
            type:'Academic',
            field:'Healthcare',
            skill:'Natural Language Processing',
            other:'',
            title:'ClinicalNER 🧬',
            date:'2025',
            description:<>
                Extracts gene, protein, symptom, and disease entities from biomedical texts, expanding raw literature 
                into structured knowledge that supports clinical research, accelerates information retrieval, and 
                improves precision in biomedical data analysis.
            </>,
            tools:[
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'}
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://darttgoblin.github.io/Dialex/Dialex.html', '_blank'),
            image: dialex,
            type:'Academic',
            field:'Social',
            skill:'Natural Language Processing',
            other:'',
            title:'Dialex 👳🏻',
            date:'2025',
            description: <>
                AI system detecting and classifying Arabic dialects across regions using a Twitter comments dataset, 
                achieving {StyleMetrics('71%')} test accuracy, enhancing linguistic understanding and improving dialect 
                recognition in Arabic text analysis and applications.
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'}
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://github.com/DarttGoblin/NoteX', '_blank'),
            image: notex,
            type:'Personal',
            field:'Education',
            skill:'Browser Extensions',
            other:'',
            title:'NoteX 📌',
            date:'2025',
            description:<>
                Browser extension that instantly saves highlighted text from any webpage, storing notes directly on 
                the hard disk through a local text file. Ensures secure retention after refresh or shutdown while 
                providing organized storage and efficient information capture.
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'}
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://github.com/DarttGoblin/Chronix', '_blank'),
            image: chronix,
            type:'Personal',
            field:'Education',
            skill:'Browser Extensions',
            other:'',
            title:'Chronix ⏰',
            date:'2025',
            description:<>
                Manages tasks, deadlines, and personal goals through smart reminders and an integrated focus mode, 
                helping users stay organized daily. Supports progress tracking, and productivity to achieve objectives 
                with a simple, intuitive, efficient workflow.
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'}
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://darttgoblin.github.io/Herma/Herma.html', '_blank'),
            image: herma,
            type:'Personal',
            field:'Social',
            skill:'Natural Language Processing',
            other:'',
            title:'Herma 🔮',
            date:'2025',
            description: <>
                AI-powered system predicting the likelihood of divorce using behavioral data from a Turkish survey 
                dataset on Kaggle, achieving {StyleMetrics('98%')} test accuracy. Supports early identification, 
                analysis of relationship patterns for couples and counselors.
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'}
            ]
        },
        // {
        //     available:true,
        //     onClick:() => window.open('https://yassinebazgour.vercel.app/', '_blank'),
        //     image: portfolio,
        //     type:'Personal',
        //     field:'Business',
        //     skill:'Web Development',
        //     other:'',
        //     title:'Portfolio 🚀',
        //     date:'2025',
        //     description:<>
        //         Sleek personal portfolio showcasing experience in machine learning, robotics, embedded systems, and 
        //         full-stack development, featuring {StyleMetrics('3')} experiences, {StyleMetrics('+25')} projects
        //         , {StyleMetrics('+10')} certifications, and {StyleMetrics('+15')} events, presented through a clean, 
        //         responsive interface.
        //     </>,
        //     tools:[
        //         {name:'React', backgroundColor:'rgb(40, 80, 95)'},
        //         {name:'Node.js', backgroundColor:'rgb(43, 90, 50)'}
        //     ]
        // },
        {
            available:true,
            onClick:() => window.open('https://darttgoblin.github.io/Cortext/Cortext.html', '_blank'),
            image: cortext,
            type:'Academic',
            field:'Business',
            skill:'Natural Language Processing',
            other:'',
            title:'Cortext 😊',
            date:'2025',
            description:<>
                AI-powered system performing sentiment analysis using NLP and neural networks to classify emotions 
                and opinions from customer feedback and social content. Trained SVM on Twitter dataset, 
                achieving {StyleMetrics('88%')} accuracy for real-time, fine-grained classification.
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'}
            ]
        },
        // {
        //     available:true,
        //     onClick:() => window.open('https://drive.google.com/file/d/1TsXVrZmQmEfpMF_mUPjdcb787d7KsVtP/view?usp=drive_link', '_blank'),
        //     image: moroccoinsights,
        //     type:'Academic',
        //     field:'Business',
        //     skill:'Other',
        //     other:'Business Intelligence',
        //     title:'MoroccoInsights 🕌',
        //     date:'2025',
        //     description:<>
        //         Data analysis project using Power BI, and PDI to explore Morocco's demographics, population trends, 
        //         and regional indicators. Provides actionable insights for visual dashboards to support informed 
        //         decision-making and strategic planning.
        //     </>,
        //     tools:[
        //         {name:'PDI', backgroundColor:'rgb(120, 31, 31)'},
        //         {name:'Power BI', backgroundColor:'rgb(90, 75, 30)'},
        //         {name:'SQL', backgroundColor:'rgb(114, 150, 186)'}
        //     ]
        // },
        {
            available:true,
            onClick:() => window.open('https://darttgoblin.github.io/NeuroLink/NeuroLink.Pages/Home/Home.html', '_blank'),
            image: neurolink,
            type:'Academic',
            field:'Autonomous Vehicles',
            skill:'Internet of Things',
            other:'',
            title:'NeuroLink 🎮',
            date:'2025',
            
            description:<>
                Web-based interface that provides secure, real-time, and responsive control of an intelligent car using 
                embedded systems and IoT automation. Integrates sensor data, remote commands, to enhance autonomous 
                navigation and user interaction.
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'},
            ]
        },
        {
            available:true,
            onClick:() => window.open('https://github.com/DarttGoblin/NeuroDrive', '_blank'),
            image: neurodrive,
            type:'Academic',
            field:'Autonomous Vehicles',
            skill:'Robotics',
            other:'',
            title:'NeuroDrive 🚗',
            date:'2025',
            description:<>
                Autonomous vehicle system using AI and robotics on Raspberry Pi for safe, smart mobility with 
                real-time traffic interaction. Fine-tuned YOLOv8 on a custom dataset of six traffic signs, 
                achieving {StyleMetrics('88%')} F1 score for fast, reliable onboard detection.
            </>,
            tools:[
                {name:'Python', backgroundColor:'rgb(45, 70, 90)'},
                {name:'Raspberry Pi ', backgroundColor:'rgb(95, 40, 55)'}
            ]
        },
        // {
        //     available:true,
        //     onClick:() => window.open('https://darttgoblin.github.io/TheraBot/TheraBot.html', '_blank'),
        //     image: therabot,
        //     type:'Academic',
        //     field:'Healthcare',
        //     skill:'Other',
        //     other:'Expert Systems',
        //     title:'Therabot 💊',
        //     date:'2025',
        //     description:<>
        //         Diagnostic chatbot for identifying digestive system diseases. Supports {StyleMetrics('10')} digestive 
        //         disease diagnoses, {StyleMetrics('10')} symptoms for each, providing guidance to assist users.
        //     </>,
        //     tools:[
        //         {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
        //         {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
        //         {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
        //         {name:'Node.js', backgroundColor:'rgb(43, 90, 50)'},
        //         {name:'Prolog', backgroundColor:'rgb(135, 92, 31)'}
        //     ]
        // },
        {
            available:true,
            onClick:() => window.open('https://heatz.ma/', '_blank'),
            image: heatz,
            type:'Professional',
            field:'Business',
            skill:'Web Development',
            other:'',
            title:'Heatz 🛒',
            date:'2024',
            description:<>
                E-commerce platform offering diverse tech products and accessories, built collaboratively by a two-person 
                team using React, Node.js, and MongoDB, delivering catalog, cart, authentication, and admin dashboard as 
                real-world full-stack experience.
            </>,
            tools:[
                {name:'React', backgroundColor:'rgb(40, 80, 95)'},
                {name:'Node.js', backgroundColor:'rgb(43, 90, 50)'},
            ]
        },
        // {
        //     onClick:() => {ShowMessage('Project is currently undergoing maintenance and will be available shortly!', 'warning')},
        //     image: medieval,
        //     type:'Personal',
        //     field:'Art',
        //     skill:'Web Development',
        //     other:'',
        //     title:'Medieval 🏰',
        //     date:'2024',
        //     description: <>
        //         Immerses users in the Middle Ages through interactive paintings, classical music, and medieval-themed 
        //         digital experiences. Offers an engaging journey into art, combining multimedia elements to create a rich, 
        //         educational, and entertaining experience.
        //     </>,
        //     tools:[
        //         {name:'React', backgroundColor:'rgb(40, 80, 95)'}
        //     ]
        // },
        // {
        //     available:true,
        //     onClick:() => window.open('https://darttgoblin.github.io/Whisper/Login.html', '_blank'),
        //     image: whisper,
        //     type:'Personal',
        //     field:'Social',
        //     skill:'Web Development',
        //     other:'',
        //     title:'Whisper 💬',
        //     date:'2024',
        //     description:<>
        //         Real-time chat application featuring instant messaging, responsive design, and smooth user 
        //         interaction, {Issues('currently facing a database hosting issue')}. Work is underway to 
        //         restore stable persistence.
        //     </>,
        //     tools:[
        //         {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
        //         {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
        //         {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
        //         {name:'Node.js', backgroundColor:'rgb(43, 90, 50)'},
        //         {name:'SQL', backgroundColor:'rgb(114, 150, 186)'}
        //     ]
        // },
        // {
        //     available:true,
        //     onClick:() => window.open('https://darttgoblin.github.io/LogSpectrum/InterfaceEmbPages/About/About.html', '_blank'),
        //     image: logspectrum,
        //     type:'Academic',
        //     field:'Cybersecurity',
        //     skill:'Web Development',
        //     other:'',
        //     title:'LogSpectrum 📊',
        //     date:'2024',
        //     description:<>
        //         Analyzes Snort logs for efficient intrusion-detection monitoring, and leveraging an IsolationForest model to 
        //         automatically detect anomalies and highlight suspicious network behavior.
        //     </>,
        //     tools:[
        //         {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
        //         {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
        //         {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
        //         {name:'Node.js', backgroundColor:'rgb(43, 90, 50)'},
        //         {name:'Snort', backgroundColor:'rgb(69, 52, 52)'},
        //         {name:'SQL', backgroundColor:'rgb(114, 150, 186)'}
        //     ]
        // },
        // {
        //     available:true,
        //     onClick:() => window.open('https://drive.google.com/file/d/1VtVaaoEki3sajOWkKqXPxoxK0LmDBCii/view?usp=drive_link', '_blank'),
        //     image: cabinetpro,
        //     type:'Academic',
        //     field:'Healthcare',
        //     skill:'Other',
        //     other:'UML Modeling',
        //     title:'CabinetPro 🗄️',
        //     date:'2023',
        //     description:<>
        //         UML-based conceptual model for efficiently managing medical cabinet operations, including appointments, billing, 
        //         and patient data. Developed as a comprehensive project, realizing {StyleMetrics('9')} UML diagrams to structure 
        //         processes, and support healthcare system design.
        //     </>,
        //     tools:[
        //         {name:'UML', backgroundColor:'rgb(181, 181, 181)'}
        //     ]
        // },
        {
            // available:true,
            // onClick:() => window.open('https://darttgoblin.github.io/iBulk/iBulk.html', '_blank'),
            onClick:() => {ShowMessage('Project is currently undergoing maintenance and will be available shortly!', 'warning')},
            image: ibulk,
            type:'Personal',
            field:'Sport',
            skill:'Web Development',
            other:'',
            title:'iBulk 🏋️‍♂️',
            date:'2022',
            description: <>
                Fitness website providing workout plans, nutrition guidance, and progress 
                tracking. {Issues('Mobile responsiveness is currently in progress')} to ensure seamless access across all devices.
            </>,
            tools:[
                {name:'HTML', backgroundColor:'rgb(134, 67, 67)'},
                {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
                {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
                {name:'Node.js', backgroundColor:'rgb(43, 90, 50)'},
                {name:'SQL', backgroundColor:'rgb(114, 150, 186)'}
            ]
        },
        // {
        //     available:true,
        //     onClick:() => window.open('https://github.com/DarttGoblin/SchoolPad', '_blank'),
        //     image: schoolpad,
        //     type:'Academic',
        //     field:'Education',
        //     skill:'Other',
        //     other:'Desktop Applications',
        //     title:'SchoolPad 📚',
        //     date:'2022',
        //     description:<>
        //         Student app built in C to add, view, and delete notes using dynamic memory allocation, efficiently managing 
        //         academic tasks and course materials. Supports organized study, quick access, and streamlined handling of 
        //         educational resources for daily student use.
        //     </>,
        //     tools:[
        //         {name:'C', backgroundColor:'rgb(40, 65, 105)'},
        //     ]
        // },
        // {
        //     available:true,
        //     onClick:() => window.open('https://darttgoblin.github.io/ColorClash/ColorClash.html', '_blank'),
        //     image: colorclash,
        //     type:'Personal',
        //     field:'Art',
        //     skill:'Web Development',
        //     other:'',
        //     title:'Color Clash 🎨',
        //     date:'2021',
        //     description:<>
        //         Modern remake of the classic Color Clash game where players guess the correct RGB color, featuring multiple 
        //         difficulty levels, interactive gameplay, responsive design, and dynamic scoring, designed to enhance color 
        //         recognition skills and provide engaging.
        //     </>,
        //     tools:[
        //         {name:'Html', backgroundColor:'rgb(134, 67, 67)'},
        //         {name:'CSS', backgroundColor:'rgb(32, 57, 101)'},
        //         {name:'JavaScript', backgroundColor:'rgb(81, 75, 20)'},
        //     ]
        // }
    ];

    return (
        <>
            <SEO 
                title="Projects"
                description="Explore my portfolio of 40+ innovative projects in AI, machine learning, deep learning, computer vision, NLP, robotics, IoT, and full-stack web development. Real-world applications with measurable results including neural networks, recommendation systems, medical AI, and more."
                url="https://yassinebazgour.vercel.app/Projects"
                keywords="AI projects, machine learning portfolio, computer vision projects, NLP applications, deep learning projects, neural networks, robotics projects, IoT systems, web development projects, React projects, Python AI projects, TensorFlow projects, PyTorch projects"
            />
            <section className='projects-section'>
                <span className='projects-title'>Projects</span>
                <span className='projects-description'>A list of some projects and side projects I worked on.</span>
                <span className='projects-count-span'>
                    Built Projects:
                    <span className='projects-count-number'> {projects.filter(p => p.available).length}</span>
                </span>
                <div className='projects-selects-container'>
                    <select className='projects-select projects-type-select' onChange={(e) => handleFilterChange(e, setSelectedType)}>
                        <option>All Types</option>
                        <option>Academic</option>
                        <option>Professional</option>
                        <option>Personal</option>
                    </select>
                    <select className='projects-select projects-field-select' onChange={(e) => handleFilterChange(e, setSelectedField)}>
                        <option>All Fields</option>
                        <option>Healthcare</option>
                        <option>Education</option>
                        <option>Business</option>
                        <option>Autonomous Vehicles</option>
                        <option>Cybersecurity</option>
                        <option>Social</option>
                        <option>Sport</option>
                        <option>Art</option>
                    </select>
                    <select className='projects-select projects-skill-select' onChange={(e) => handleFilterChange(e, setSelectedSkill)}>
                        <option>All Skills</option>
                        <option>Generative AI</option>
                        <option>Computer Vision</option>
                        <option>Natural Language Processing</option>
                        <option>Recommandation Systems</option>
                        <option>Robotics</option>
                        <option>Internet of Things</option>
                        <option>RAG Systems</option>
                        <option>Web Development</option>
                        <option>Web Scraping</option>
                        <option>Browser Extensions</option>
                    </select>
                    <select className='projects-select projects-date-select' onChange={(e) => handleFilterChange(e, setSelectedDate)}>
                        <option>All Years</option>
                        <option>2026</option>
                        <option>2025</option>
                        <option>2024</option>
                        {/* <option>2023</option> */}
                        <option>2022</option>
                        {/* <option>2021</option> */}
                    </select>
                </div>
                <div className='projects-container'>
                    {projects.filter(filterProjects).length === 0 ? (
                        <span className='no-available-project'>No projects are available for the selected filters. 😔</span>
                    ) : (
                        projects.filter(filterProjects).map((project, index) => (
                            <Project 
                                key={index}
                                {...project}
                            />
                        ))
                    )}
                </div>
            </section>
        </>
    )
}

export default Projects

export const StyleMetrics = (text) => {return <span className='project-metric'>{text}</span>;};
export const Issues = (text) => {return <span style={{ color:'rgba(181, 32, 32, 1)'}}>{text}</span>;};